
import { StepItem } from "./StepItem";
import { useIsMobile } from "@/hooks/use-mobile";
import { Shield, Zap } from "lucide-react";

export function HowItWorksSection() {
  const isMobile = useIsMobile();
  
  const steps = [
    {
      title: "Sign Up for Free",
      description: "Create an account in seconds with no credit card required."
    },
    {
      title: "Enter Your Hours",
      description: "Log your work time manually for precise tracking."
    },
    {
      title: "Organize Projects",
      description: "Create unlimited projects with custom rates for different clients."
    },
    {
      title: "Export Invoices",
      description: "Generate professional invoices based on your tracked time."
    },
    {
      title: "Monitor Your Productivity",
      description: "Visualize your work patterns and earnings with detailed analytics."
    }
  ];

  const benefits = [
    {
      icon: Zap,
      title: "Simple & Fast Workflow",
      description: "Clean interface with no learning curve. Log time entries and generate invoices in seconds."
    },
    {
      icon: Shield,
      title: "Secure & Reliable",
      description: "Your data is protected with enterprise-grade security and regular backups."
    }
  ];

  return (
    <section className="py-14 bg-white">
      <div className="container max-w-4xl mx-auto px-4">
        <h2 className="text-xl md:text-3xl font-bold mb-6 md:mb-8 text-center">
          How It Works
        </h2>
        
        <div className="space-y-4 md:space-y-5 mb-8 md:mb-12 max-w-2xl mx-auto">
          {steps.map((step, index) => (
            <StepItem
              key={index}
              number={index + 1}
              title={step.title}
              description={step.description}
              compact={isMobile}
            />
          ))}
        </div>
        
        <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className="flex gap-4 p-5 rounded-lg bg-muted/10">
                <div className="bg-primary/10 p-2 rounded-full h-fit">
                  <Icon className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">{benefit.title}</h3>
                  <p className="text-sm text-muted-foreground">{benefit.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
